import { setClass, useOutsideClick } from '@utils';
import React, { FC, Fragment, useEffect, useRef } from 'react';

interface DateTimePickerProp {
  left: number,
  top: number,
  onOuterClick: () => void;
  onClick: (hours: number, minutes: number) => void;
  time: Date;
  isBig?: boolean;
}

export const EditMeetingTimePickerList: FC<DateTimePickerProp> = ({
  onClick, left, top, onOuterClick, time, isBig
}) => {
  const listRef = useOutsideClick(onOuterClick);
  const timeRef = useRef<HTMLDivElement>();
  const isTimeSelected = (hours: number, minutes: number) => time.getHours() === hours && time.getMinutes() === minutes;
  const isTimeApproximated = (hours: number, minutes: boolean) => time.getHours() === hours && minutes;
  const styleColor = (hours: number, minutes: number) => (isTimeSelected(hours, minutes) ? { color: '#3273E1' } : {});

  useEffect(() => {
    timeRef.current?.scrollIntoView({ block: 'center' });
  }, []);

  return (
    <div
      className="time-picker-list"
      style={{ left, top }}
      ref={listRef}
    >
      <div className={setClass("items", isBig && 'big')}>
        {Array.from(Array(24).keys()).map((hour) => (
          <Fragment key={hour}>
            <div
              className="time-list-option"
              style={styleColor(hour, 0)}
              onClick={() => onClick(hour, 0)}
              ref={isTimeApproximated(hour, time.getMinutes() >= 0 && time.getMinutes() < 15) ? timeRef : null}
            >
              {`${hour < 10 ? `0${hour}` : hour}:00`}
            </div>
            <div
              className="time-list-option"
              style={styleColor(hour, 15)}
              onClick={() => onClick(hour, 15)}
              ref={isTimeApproximated(hour, time.getMinutes() >= 15 && time.getMinutes() < 30) ? timeRef : null}
            >
              {`${hour < 10 ? `0${hour}` : hour}:15`}
            </div>
            <div
              className="time-list-option"
              style={styleColor(hour, 30)}
              onClick={() => onClick(hour, 30)}
              ref={isTimeApproximated(hour, time.getMinutes() >= 30 && time.getMinutes() < 45) ? timeRef : null}
            >
              {`${hour < 10 ? `0${hour}` : hour}:30`}
            </div>
            <div
              className="time-list-option"
              style={styleColor(hour, 45)}
              onClick={() => onClick(hour, 45)}
              ref={isTimeApproximated(hour, time.getMinutes() >= 45) ? timeRef : null}
            >
              {`${hour < 10 ? `0${hour}` : hour}:45`}
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};
